// extracted by mini-css-extract-plugin
module.exports = {"page-container":"Datavision_page-container__162iq","message":"Datavision_message__2KRH1"};